import * as devisConf from '@/configuration/devisConf';

export default function calculSousTotal(ligneCommande, lignesCommande) {
  if (!ligneCommande || ligneCommande.type !== devisConf.SOUS_TOTAL || !lignesCommande) {
    return;
  }
  let index = lignesCommande.indexOf(ligneCommande);
  if (index < 0) {
    return;
  }
  ligneCommande.totalHt = 0;
  while (index - 1 >= 0
  && (lignesCommande[index - 1] && lignesCommande[index - 1].type !== devisConf.SOUS_TOTAL)) {
    if (lignesCommande[index - 1].totalHt
      && (lignesCommande[index - 1].type === devisConf.NORMAL
        || lignesCommande[index - 1].type === devisConf.REMISE)) {
      ligneCommande.totalHt += lignesCommande[index - 1].totalHt;
    }
    index -= 1;
  }
}
